import React from "react";
import { HomeIcon } from "@heroicons/react/solid";
import { SocialIcon } from "react-social-icons";
import "../customcss.css";

export default function Contact() {
  return (
    <section id="contact" className=" container mx-auto">
      <div className="container px-5 py-10 mx-auto">
        <div className="text-center mb-20">
          <HomeIcon className="w-10 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
            Contact
          </h1>
          <SocialIcon
            className="socialIcons"
            url="https://twitter.com/tk0779"
          />
          <SocialIcon
            className="socialIcons"
            url="https://www.linkedin.com/in/tiranat-kamklai-51a4b951/"
          />
          <SocialIcon
            className="socialIcons"
            url="https://www.behance.net/tiranatkamklai"
          />
          <SocialIcon
            className="socialIcons"
            url="https://www.instagram.com/tk0779/"
          />
        </div>
      </div>
    </section>
  );
}
